import { ComboboxMulti } from '@/components/ui/inputs/combobox-multi';
import { OptionGroup } from '@/types';

export interface FacetFilterProps {
  options: OptionGroup[];
  selectedValues?: string[];
  placeholder?: string;
  onChange: (values: string[] | undefined) => void;
}

const FacetFilter = ({ options, selectedValues = [], onChange, placeholder }: FacetFilterProps) => {
  const title = options ? options[0]?.title || placeholder : placeholder;

  const handleChange = (values: string[]) => {
    onChange(values.length ? values : undefined);
  };

  return (
    <ComboboxMulti
      options={options}
      placeholder={title}
      onValueChange={handleChange}
      selectedValues={selectedValues}
      maxCount={1}
    />
  );
};

export { FacetFilter };
